/* unplugin-vue-components disabled */import { render } from "./SystemConfig.vue?vue&type=template&id=5c6339bf&scoped=true"
import script from "./SystemConfig.vue?vue&type=script&lang=js"
export * from "./SystemConfig.vue?vue&type=script&lang=js"

import "@/styles/admin-pagination.css?vue&type=style&index=0&id=5c6339bf&scoped=true&lang=css&external"
import "./SystemConfig.vue?vue&type=style&index=1&id=5c6339bf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c6339bf"]])

export default __exports__